import { render } from "./ItemAlignmentControl.vue?vue&type=template&id=aa0188c6"
import script from "./ItemAlignmentControl.vue?vue&type=script&lang=js"
export * from "./ItemAlignmentControl.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__